module.exports = __webpack_public_path__ + "static/media/stofferingen-17.46b262c9.jpg";